import React from "react";
import Badge from "reactstrap/es/Badge";
import {format, parseJSON} from "date-fns";

export { decimalToBD, decimalFromBD, estaVacio } from "./decimal.utils";
export {getErrorMessage} from "./error.utils";

export const getCurrentUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}") || {};
  } catch {
    return {};
  }
};

export const formatDate = date => {
  if (!date) return "-";
  try {
    const parsedDate =
      typeof date === "string" && !date.includes("T")
        ? new Date(date + "T00:00:00")
        : parseJSON(date);
    if (isNaN(parsedDate.getTime())) return "-";
    return format(parsedDate, "dd/MM/yyyy");
  } catch {
    return "-";
  }
};

export const formatDateTime = date => {
  if (!date) return "-";
  try {
    const parsedDate =
      typeof date === "string" && !date.includes("T")
        ? new Date(date + "T00:00:00")
        : parseJSON(date);
    if (isNaN(parsedDate.getTime())) return "-";
    return format(parsedDate, "dd/MM/yyyy HH:mm:ss");
  } catch {
    return "-";
  }
};

const parseDecimalOrNull = v => {
  if (v === null || v === undefined || v === "") return null;
  const n = typeof v === "number" ? v : Number(String(v).replace(",", "."));
  return Number.isNaN(n) ? null : n;
};

export const formatDecimal = (v, fallback = "0.00") => {
  const n = parseDecimalOrNull(v);
  return n === null ? fallback : n.toFixed(2);
};

export const formatDecimalConSeparadores = (v, fallback = "0,00") => {
  const n = parseDecimalOrNull(v);
  return n === null
      ? fallback
      : n.toLocaleString("es-ES", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
};

export const formatEstadoPresupuesto = codigoEstado => {
  let color = "";
  let text = "";

  switch (codigoEstado) {
    default:
    case 1:
      color = "primary";
      text = "Borrador";
      break;
    case 2:
      color = "success";
      text = "Aceptado";
      break;
    case 3:
      color = "info";
      text = "Entregado parcial";
      break;
    case 4:
      color = "secondary";
      text = "Entregado total";
      break;
    case 5:
      color = "danger";
      text = "Cancelado";
      break;
  }

  return (
    <Badge color={`soft-${color}`} className="rounded-capsule">
      {text}
    </Badge>
  );
};

export const formatTipoPresupuesto = codigoTipo => {
  let color = "";
  let text = "";
  let title = "";
  if (codigoTipo === 1) {
    color = "secondary";
    text = "Ordinario";
    title = "Presupuesto Ordinario";
  } else if (codigoTipo === 2) {
    color = "secondary";
    text = "Previa";
    title = "Factura Previa";
  } else {
    color = "secondary";
    text = "Cuenta";
    title = "Presupuesto a Cuenta";
  }

  return (
    <Badge color={`soft-${color}`} title={title} className="rounded-capsule">
      {text}
    </Badge>
  );
};

export const formatEstadoFacturacionPresupuesto = codigoEstadoFacturacion => {
  if (codigoEstadoFacturacion === 1) {
    return "Parcial";
  } else if (codigoEstadoFacturacion === 2) {
    return "Total";
  } else {
    return "";
  }
};

export const toDateInputValue = d => {
  if (!d) return "";
  const date = typeof d === "string" || typeof d === "number" ? new Date(d) : d;
  if (isNaN(date)) return "";
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

export const formatEstadoAlbaran = codigoEstado => {
  let color = "";
  let text = "";

  switch (codigoEstado) {
    default:
    case 1:
      color = "primary";
      text = "Pendiente";
      break;
    case 2:
      color = "success";
      text = "Confirmado";
      break;
  }

  return (
    <Badge color={`soft-${color}`} className="rounded-capsule">
      {text}
    </Badge>
  );
};

export const formatEstadoLista = codigoEstado => {
  let color = "";
  let text = "";

  switch (codigoEstado) {
    default:
    case 1:
      color = "primary";
      text = "Borrador";

      break;
    case 2:
      color = "success";
      text = "Vigente";
      break;
    case 3:
      color = "secondary";
      text = "Obsoleta";
      break;
  }

  return (
    <Badge color={`soft-${color}`} className="rounded-capsule">
      {text}
    </Badge>
  );
};

export const formatTipoAlbaran = codigoTipo => {
  let color = "";
  let text = "";

  switch (codigoTipo) {
    default:
    case 1:
      color = "success";
      text = "Ordinario";
      break;
    case 2:
      color = "info";
      text = "Previa";
      break;
    case 3:
      color = "warning";
      text = "A Cuenta";
      break;
  }

  return (
    <Badge color={`soft-${color}`} className="rounded-capsule">
      {text}
    </Badge>
  );
};
